// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3KzCe","col":"CardReaderDesc_col__1f2rj","label":"CardReaderDesc_label__3RcDG"};